export const iconFontAwesomeLogisticsRoadBarrier = (
	<i className="fa-solid fa-road-barrier"></i>
);
